// extracted by mini-css-extract-plugin
export default {"scroll":"MultiComplete_scroll__JtKxa","selectedWrapper":"MultiComplete_selectedWrapper__ffA1-"};